export default __webpack_public_path__ + "static/media/1.4cb14aa0.jpg";